import Styled from "styled-components";
import { respondTo } from "../../respondTo";

export const NavbarContainer = Styled.nav<{ shownavbar?: boolean; theme?: string }>`
    display:flex;
    position: sticky;
    top: 0;
    width: 100%;
    background-color:${({ shownavbar, theme }) =>
      shownavbar && theme === "dark" ? " rgb(0, 51, 82)" : shownavbar && theme === "light" ? "var(--background-light)" : ""};
    color: ${({ shownavbar, theme }) =>
      shownavbar && theme === "dark" ? "var(--background-light)" : shownavbar && theme === "light" ? "var(--on-surface-light)" : "var(--on-surface-dark)"};
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0 0.75rem 0;
    transition: transform 0.1s ease;
    transform: translateY(${({ shownavbar }) => (shownavbar ? "0" : "-100%")});
    opacity: ${({ shownavbar }) => (shownavbar ? "1" : "0")};
    backdrop-filter: ${({ shownavbar }) => (shownavbar ? "blur(10px)" : "none")};
    z-index: 100;
    border-bottom: ${({ theme }) =>
      theme === "light" ? "1px solid var(--on-surface-light)" : theme === "dark" ? "1px solid var(--on-surface-dark)" : "1px solid var(--on-primary-light)"};
   
    
    ${respondTo.tablet_landscape_s`
    padding:0.625rem 0;
    `}

    ${respondTo.desktop_xl`
    padding:1.25rem 0;
 
    `}
`;

export const NavbarBox = Styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1512px;
      margin: 0 auto;
      padding: 0 0.625rem 0 1.25rem;


      ${respondTo.tablet_landscape_s`
        padding:0 2.5rem
    `}

      ${respondTo.desktop_xl`
          padding:0 4.375rem;
            
      `}
`;

export const LogoIcon = Styled.div`
    /* position: relative;
    width: 79.77px;
    height: 21.87px;
    ${respondTo.tablet_landscape_s`
     width: 127.15px;
    height: 34.86px;
    align-self: flex-start;
    `}
    ${respondTo.desktop_xl`
    width: 150px;
    height: 41.25px; 
    `} */

  width:100%;
`;
export const ImgLogo = Styled.img`
    width: 79.77px;
    height: 21.87px;
    fill: #006a64 !important;
    color: #006a64 !important;

    & path {
        fill: #006a64 !important;
        color: #006a64 !important;
    }

    ${respondTo.tablet_landscape_s`
     width: 127.15px;
    height: 34.86px;
    align-self: flex-start;
    `}
    ${respondTo.desktop_xl`
    width: 150px;
    height: 41.25px; 
    `}
`;

export const MenuIconSmall = Styled.div<{ onClick?: any }>`
cursor: pointer;
display: flex;
justify-content: space-between;
padding: 0 0.625rem 0 0;

 ${respondTo.tablet_landscape_s`
    display: none;
    `}
`;

export const MenuStyle = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    backgroundColor: "var(--surface-light)",
    color: "var(--primary-light)",
    mt: 1.5,

    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

export const MenuLargeContainer = Styled.div`
      display: none;
      ${respondTo.tablet_landscape_s`
      display: block;
      
      `}
      `;
